import { PayloadAction, createSlice } from "@reduxjs/toolkit"

const initialState: any = {
  ordersList: [],
  openOrder: {},
  clearMessageCountId: ""
}

export const ordersSlice = createSlice({
  name: "ordersList",
  initialState,
  reducers: {
    updateOrdersList: (state: any, action: PayloadAction<any>) => {
      state.ordersList = [...state.ordersList, ...action.payload.list]
    },
    setNeedClearNewMessageCount: (state: any, action: PayloadAction<any>) => {
      state.clearMessageCountId = action.payload
    },
    setOpenOrder: (state: any, action: PayloadAction<any>) => {
      state.openOrder = action.payload
    },
    changeOrderHasRevied: (state: any, action: PayloadAction<any>) => {
      const updatedArray = state.ordersList.map((el: any) => {
        if (el.id === action.payload.id) {
          return { ...el, hasReview: action.payload.hasReview }
        } else return {...el}
      })

      state.ordersList = updatedArray
    },
  },
})

export const { updateOrdersList, changeOrderHasRevied, setOpenOrder, setNeedClearNewMessageCount } = ordersSlice.actions

export const selectOpenOrder = (state: any) => state[ordersSlice.name].openOrder
export const clearMessageCountId = (state: any) => state[ordersSlice.name].clearMessageCountId